export default __webpack_public_path__ + "static/media/p20.bd32b541.jpg";